<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm border-t border-n-weak">
    <button
      class="flex items-center gap-2 select-none w-full min-h-12 bg-transparent m-0 cursor-grab justify-between py-3 px-4 drag-handle hover:bg-n-slate-2 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-n-blue-8"
      type="button"
      :aria-expanded="isOpen"
      @click.stop="onToggle"
    >
      <div class="flex min-w-0 items-center gap-2">
        <EmojiOrIcon class="inline-block w-5" :icon="icon" :emoji="emoji" />
        <h5 class="text-n-slate-12 text-xs font-semibold mb-0 py-0 text-start">
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row">
        <slot name="button" />
        <span
          class="i-lucide-chevron-down size-3.5 shrink-0 text-n-slate-11 transition-transform"
          :class="{ 'rotate-180': isOpen }"
          aria-hidden="true"
        />
      </div>
    </button>
    <div
      v-if="isOpen"
      class="border-t-0"
      :class="compact ? 'p-0' : 'px-4 pt-1 pb-4'"
    >
      <slot />
    </div>
  </div>
</template>
